var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("textBlocks")))]),
              _c(
                "w-list",
                [
                  _vm._l(_vm.layout.TextBlocks, function (block, i) {
                    return _c(
                      "w-list-item",
                      { key: block.key },
                      [
                        _c("w-list-item-text", [
                          _vm._v(" " + _vm._s(block.getName(_vm.model)) + " "),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("edit-block"),
                                    expression: "$ct('edit-block')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.editBlock(block)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("delete-block"),
                                    expression: "$ct('delete-block')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteBlock(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addNewBlock()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(" " + _vm._s(_vm.$ct("create-new-block")) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditBlock
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-text-block-settings", {
                attrs: {
                  block: _vm.toEditBlock,
                  model: _vm.model,
                  layout: _vm.layout,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }